// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/collapse/style/index.css
// module id = 823
// module chunks = 0